import React, { Component, MouseEvent } from 'react';
import ComponentName from '../../constant/ComponentName';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../components/custom/FormicaSearchSelectBox';
import ItemToolsMenu from '../../components/ItemToolsMenu';
import { AlarmCloseCode, CaseSettings, CloseCaseBulkActionOperation, CaseAction, CaseActionStatus } from '../../domain/case/CaseDomains';
import { dispatch, RootState } from '../../redux/store';
import { PageState } from '../../redux/reducers/PageReducer';
import { UserSystemAttributes, UserSystemTableAttributes } from '../../domain/rbac/RbacDomains';
import { ComponentState, setSelectedItems } from '../../redux/actions/ComponentActions';
import { CaseState } from '../../redux/reducers/CaseReducer';
import { connect } from 'react-redux';
import { changePageFilter, clearPage } from '../../redux/actions/PageActions';
import { changeCaseColumns } from '../../redux/actions/CaseActions';
import { setAttribute } from '../../redux/actions/UserActions';
import { ConnectedProps } from 'react-redux/es/exports';
import { query } from '@trlogic/client-js';
import { TransactionData, TransactionReason } from '../../domain/stream/transaction/TransactionDomains';
import { customConfirm } from '../../components/custom/CustomPopupConfirm';
import Icon from '../../icons/Icon';
import MessageUtil from '../../util/MessageUtil';
import LanguageUtil from '../../util/LanguageUtil';
import CaseService from '../../service/CaseService';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import { TransactionDataExportJob } from '../../domain/job/JobDomain';
import moment from 'moment/moment';
import JobService from '../../service/JobService';
import TransactionPageUtil from './TransactionPageUtil';
import { Skeleton } from 'primereact/skeleton';
import TransactionMarkComponent from '../../components/investigation/case/modal/TransactionMarkComponent';
import TransactionChatComponent from '../../components/investigation/case/modal/TransactionChatComponent';
import Filter = query.Filter;
import and = query.and;
import empty = query.empty;
import or = query.or;
import eq = query.eq;
import Order = query.Order;
import {
  ACTION_NOT_PERMITTED_ERROR,
  assertCanPerformAction,
  canPerformBulkClose,
  hasCasesActionPermission,
  notifyActionNotPermitted,
} from '../../util/CaseBulkCloseUtil';
import { buildExportColumnPreferences } from '../../util/ColumnExportUtil';

class TransactionItemToolsMenu extends Component<Props, State> {
  public state: State = new State();

  private readonly transactionService: CaseService = ServiceContainer.getInstance().get(ServiceNames.CASE);
  private readonly jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);

  public render() {
    const { currentCaseSettings, onChangeFilter, loading, filter, user } = this.props;
    const { markVisible, chatVisible } = this.state;

    const columns = this.getColumn();

    if (loading) {
      return (
        <div className='flex flex-col w-full h-full gap-2 p-2'>
          <Skeleton width='100%' height='30px' />
          <Skeleton width='100%' height='30px' />
        </div>
      );
    }
    return (
      <>
        <ItemToolsMenu
          key={currentCaseSettings?.dataSource}
          views={false}
          acceptFunc={(e) => this.closeBulk(e, 'NOT_FRAUD')}
          rejectFunc={(e) => this.closeBulk(e, 'FRAUD')}
          acceptLabel={
            user?.activeRiskType == 'fraud'
              ? LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' })
              : LanguageUtil.get({ id: 'common.label.compliant', defaultMessage: 'Compliant' })
          }
          rejectLabel={
            user?.activeRiskType == 'fraud'
              ? LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' })
              : LanguageUtil.get({ id: 'common.label.inCompliant', defaultMessage: 'Incompliant' })
          }
          exportVisible={currentCaseSettings != undefined}
          acceptVisible={currentCaseSettings != undefined && canPerformBulkClose(user?.username ?? '', currentCaseSettings, 'Cases')}
          rejectVisible={currentCaseSettings != undefined && canPerformBulkClose(user?.username ?? '', currentCaseSettings, 'Cases')}
          markVisible={currentCaseSettings != undefined}
          chatVisible={!!currentCaseSettings?.name}
          actionVisible={currentCaseSettings != undefined && hasCasesActionPermission()}
          actionFunc={this.actionBulk}
          chatFunc={() => this.setState({ chatVisible: true })}
          markFunc={() => this.setState({ markVisible: true })}
          exportFunc={this.exportTransactions}
          importVisible={false}
          exportVisibleAlways={true}
          onChangeFilter={onChangeFilter}
          componentLabel={LanguageUtil.get({ id: 'common.label.transaction', defaultMessage: 'Transaction' })}
          component={ComponentName.CASE}
          componentId={currentCaseSettings?.name || 'All'}
          filter={filter}
          preferences={{
            columnPreferencesVisible: true,
            columns: columns.map((c) => ({ label: c.header, value: c.field })) as FormicaSelectBoxItem[],
            selectedColumns: columns
              .filter((c) => {
                return !c.hidden;
              })
              .map((c) => ({ label: c.header, value: c.field })) as FormicaSelectBoxItem[],
            onChangeColumnPreferences: (selectedColumns: FormicaSelectBoxItem[]) => {
              this.onChangeColumnPreferences(selectedColumns);
            },
          }}
        />
        <TransactionMarkComponent markVisible={markVisible} onHideMark={this.onHideMark} currentCaseSettings={currentCaseSettings} />
        <TransactionChatComponent visible={chatVisible} onClose={this.onHideChat} domain={currentCaseSettings?.name} />
      </>
    );
  }

  private onChangeColumnPreferences = (selectedColumns: FormicaSelectBoxItem[]) => {
    const {
      changeCaseColumns,
      case: { columns },
      attributes,
      currentCaseSettings,
      setAttribute,
    } = this.props;
    const hiddenColumns: string[] = [];
    for (const column of this.getColumn()) {
      column.hidden = selectedColumns.find((c) => c.value == column.field) == undefined;
      if (column.hidden) {
        hiddenColumns.push(column.field!);
      }
    }
    let table: UserSystemTableAttributes | undefined = attributes.table.find(
      (t) => t.component == ComponentName.CASE && t.id == currentCaseSettings?.dataSource,
    );
    if (table == undefined) {
      table = {
        id: currentCaseSettings?.dataSource,
        component: ComponentName.CASE,
        columnOrder: [],
        hiddenColumns: [],
        pageSize: 0,
      };
      attributes.table.push(table);
    }
    table.hiddenColumns = hiddenColumns;
    setAttribute(attributes);
    changeCaseColumns(columns);
  };

  private getColumn = () => {
    const {
      case: { columns },
    } = this.props;
    const column = Object.values(columns);
    return column && column.length > 0 ? column[0] : [];
  };

  private actionBulk = async (e: MouseEvent<HTMLButtonElement>) => {
    const {
      component: { selectedComponentIds },
      currentCaseSettings,
    } = this.props;
    if (!currentCaseSettings) return;
    if (!assertCanPerformAction()) {
      return;
    }
    customConfirm({
      target: e.currentTarget,
      rejectIcon: <Icon icon={'close'} className={'text-[#1873D5]'} size={20} />,
      acceptIcon: <Icon icon={'check'} className={'text-white'} size={20} />,
      rejectLabel: LanguageUtil.get({ id: 'components.itemToolsMenu.cancel', defaultMessage: 'Cancel' }),
      acceptLabel: LanguageUtil.get({ id: 'components.itemToolsMenu.okay', defaultMessage: 'Okay' }),
      accept: async () => {
        if (this.state.action == undefined) return;
        try {
          await this.transactionService.actionBulk(this.state.action, selectedComponentIds);
          MessageUtil.success({
            summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
            detail: <div>{LanguageUtil.get({ id: `messages.success.caseAction`, defaultMessage: 'Case action success' })}</div>,
          });
          this.setState({ action: undefined });
          dispatch(setSelectedItems([]));
        } catch (error: unknown) {
          const isNotPermittedError: boolean = error instanceof Error && error.message === ACTION_NOT_PERMITTED_ERROR;
          const isUnauthorizedResponse: boolean =
            typeof error === 'object' && error != null && 'response' in error &&
            (error as { response?: { status?: number } }).response?.status === 401;
          if (isNotPermittedError || isUnauthorizedResponse) {
            notifyActionNotPermitted();
          } else {
            MessageUtil.error({
              summary: LanguageUtil.get({ id: 'common.label.case', defaultMessage: 'Case' }),
              detail: (
                <div>{LanguageUtil.get({ id: 'messages.error.error', defaultMessage: 'Error.' })}</div>
              ),
            });
          }
          this.setState({ action: undefined });
        }
      },
      reject: async () => {
        this.setState({ action: undefined });
      },
      message: (
        <FormicaSearchSelectBox
          placeholder={LanguageUtil.get({ id: 'common.input.placeholder.actions', defaultMessage: 'Actions' })}
          rounded
          options={this.getActionOptions(currentCaseSettings.actions)}
          value={this.state.action}
          onChange={(e: FormicaSelectBoxItem) => this.setState({ action: e.value })}
        />
      ),
    });
  };

  private getActionOptions = (actions: CaseAction[] | undefined): FormicaSelectBoxItem[] => {
    if (actions == undefined) return [];
    return actions.map((action) => ({ label: action.name, value: action.name }));
  };

  private closeBulk = async (e: MouseEvent<HTMLButtonElement>, type: string) => {
    const {
      component: { selectedComponentIds },
      user,
      currentCaseSettings,
    } = this.props;
    const selectedIds: CloseCaseBulkActionOperation[] = selectedComponentIds.map((component: TransactionData) => ({
      id: component.id,
      index: component._index,
    }));
    if (!currentCaseSettings) return;
    if (!canPerformBulkClose(user.username, currentCaseSettings, 'Cases')) {
      return;
    }
    customConfirm({
      target: e.currentTarget,
      rejectIcon: <Icon icon={'close'} className={'text-[#1873D5]'} size={20} />,
      acceptIcon: <Icon icon={'check'} className={'text-white'} size={20} />,
      rejectLabel: LanguageUtil.get({ id: 'components.itemToolsMenu.cancel', defaultMessage: 'Cancel' }),
      acceptLabel: LanguageUtil.get({ id: 'components.itemToolsMenu.okay', defaultMessage: 'Okay' }),
      accept: async () => {
        const riskType = user.activeRiskType;
        const _type =
          type == 'FRAUD'
            ? riskType == 'fraud'
              ? TransactionReason.FRAUD
              : TransactionReason.IN_COMPLIANT
            : riskType == 'fraud'
              ? TransactionReason.NOT_FRAUD
              : TransactionReason.COMPLIANT;
        try {
          const closeMode = await this.transactionService.closeBulkCase(
            user,
            currentCaseSettings.name,
            selectedIds,
            _type,
            this.state.reason,
            currentCaseSettings,
          );
          if (closeMode === 'CASE_BATCH_CLOSE') {
            MessageUtil.success({
              summary: LanguageUtil.get({ id: 'common.label.case', defaultMessage: 'Case' }),
              detail: (
                <div>
                  {LanguageUtil.get({
                    id: 'messages.success.bulkCloseScheduled',
                    defaultMessage: 'Bulk close job scheduled',
                  })}
                </div>
              ),
            });
          } else {
        MessageUtil.success({
          summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
          detail: <div>{LanguageUtil.get({ id: `messages.success.caseClosed`, defaultMessage: 'Case closed' })}</div>,
        });
          }
        this.setState({ reason: undefined });
        dispatch(setSelectedItems([]));
        } catch (error: unknown) {
          if (error instanceof Error && error.message === 'NO_TRANSACTIONS_TO_BULK_CLOSE') {
            this.setState({ reason: undefined });
            return;
          }
          const isUnauthorizedResponse: boolean =
            typeof error === 'object' &&
            error != null &&
            'response' in error &&
            (error as { response?: { status?: number } }).response?.status === 401;
          if (isUnauthorizedResponse) {
            this.setState({ reason: undefined });
            return;
          }
          MessageUtil.error({
              summary: LanguageUtil.get({ id: 'common.label.case', defaultMessage: 'Case' }),
              detail: (
                <div>{LanguageUtil.get({ id: 'messages.error.error', defaultMessage: 'Error.' })}</div>
              ),
            });
          this.setState({ reason: undefined });
        }
      },
      reject: async () => {
        this.setState({ reason: undefined });
      },
      message: (
        <FormicaSearchSelectBox
          placeholder={LanguageUtil.get({ id: 'common.input.placeholder.reason', defaultMessage: 'Reason' })}
          options={this.prepareReasonSelectBox(type)}
          value={this.state.reason}
          onChange={(e: FormicaSelectBoxItem) => this.setState({ reason: e.value })}
        />
      ),
    });
  };

  private prepareReasonSelectBox = (type: string): any => {
    const { user, currentCaseSettings } = this.props;
    const riskType = user.activeRiskType;
    const _type = type == 'FRAUD' ? (riskType == 'fraud' ? 'FRAUD' : 'IN_COMPLIANT') : riskType == 'fraud' ? 'NOT_FRAUD' : 'COMPLIANT';
    return currentCaseSettings?.closeCodes
      .filter((r) => r.status == _type)
      .map((reason: AlarmCloseCode) => {
        return {
          label: reason.code,
          value: reason.code,
        };
      });
  };

  private exportTransactions = async () => {
    const {
      component: { selectedComponentIds },
      page,
      currentCaseSettings,
      caseSettings,
      filter,
      sorts,
      rows,
      currentPage,
    } = this.props;
    try {
      if (currentCaseSettings == undefined) return;
      const _query = TransactionPageUtil.getTransactionQuery(currentCaseSettings, caseSettings, filter, rows, currentPage, sorts);
      if (selectedComponentIds.length > 0) {
        _query.filter = and(_query.filter || empty(), or(...selectedComponentIds.map((id: TransactionData) => eq('id', id.id))));
      }

      const columns = this.getColumn();
      const selectedColumns = buildExportColumnPreferences(columns);

      const job: TransactionDataExportJob = {
        type: 'CASE_DATA_EXPORT',
        timestamp: moment().valueOf(),
        status: 'PENDING',
        transaction: currentCaseSettings.dataSource,
        query: _query,
        extension: 'csv',
        path: '',
        columnPreferences: selectedColumns,
      };
      await this.jobService.schedule(job);
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'common.label.export' }),
        detail: <div>{LanguageUtil.get({ id: 'messages.success.exportScheduled', defaultMessage: 'Export job scheduled' })}</div>,
      });
    } catch (e) {
      console.error(e);
    }
  };

  private onHideMark = () => {
    this.setState({ markVisible: false });
  };

  private onHideChat = () => {
    this.setState({ chatVisible: false });
  };
}

class State {
  reason: string | undefined;
  action: string | undefined;
  markVisible: boolean = false;
  chatVisible: boolean = false;
}

interface Props extends ReduxProps {
  currentCaseSettings: CaseSettings | undefined;
  caseSettings: Pick<CaseSettings, 'id' | 'name' | 'dataSource' | 'keyField'>[];
  totalRecord: number;
  onChangeFilter: (filter: Filter) => void;
  filter: Filter;
  sorts: Order[];
  rows: number;
  currentPage: number;
  loading: boolean;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  page: state.page as PageState,
  attributes: state.auth.attributes as UserSystemAttributes,
  component: state.component as ComponentState,
  case: state.case as CaseState,
});
const connector = connect(mapStateToProps, { clearPage, changePageFilter, changeCaseColumns, setAttribute });
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(TransactionItemToolsMenu);
